import { useRedirectToError } from '@/composables/useRedirectToError.js'

export function useApiErrorHandler(router) {
  async function handleErrors(error, { redirect = true } = {}) {
    if (error?.response?.status === 422) {
      return {
        validationErrors: getValidationErrors(error),
        shouldRedirect: false,
      }
    }

    if (redirect) {
      await useRedirectToError(router).redirect()
    }

    return {
      validationErrors: null,
      shouldRedirect: true,
    }
  }

  function getValidationErrors(error) {
    const errorList = error?.response?.data?.errors

    if (!Array.isArray(errorList)) return null

    const result = {}

    for (const err of errorList) {
      const pointer = err?.source?.pointer

      if (pointer) {
        // Extract the last segment as the field key
        const segments = pointer.split('/')
        const key = segments[segments.length - 1]

        if (!result[key]) {
          result[key] = []
        }

        result[key].push(err?.detail ?? 'Unknown error')
      }
    }

    return Object.keys(result).length ? result : null
  }

  function getFieldErrors(errors, field) {
    if (!errors || typeof errors !== 'object') {
      return []
    }
    return Array.isArray(errors[field]) ? errors[field] : []
  }

  function getFlatMessages(error) {
    const errorList = error?.response?.data?.errors

    if (Array.isArray(errorList)) {
      return errorList.map((e) => e?.detail ?? null).filter(Boolean)
    }

    const message = error?.response?.data?.message
    return message ? [message] : null
  }

  return {
    handleErrors,
    getValidationErrors,
    getFieldErrors,
    getFlatMessages,
  }
}
